// extracted by mini-css-extract-plugin
module.exports = {"Container":"ChooseWorldScreen_Container__1RMyH","Title":"ChooseWorldScreen_Title__KEOQT","PlanetContainer":"ChooseWorldScreen_PlanetContainer__2lPBS"};